export default {"src":"/_next/static/media/INFO.548d9545.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};